module.exports = __webpack_public_path__ + "img/rank_1.d4ec44b2.png";